<template>
  <div class="uk-width-1-4 navigation-profile">
    <div class="uk-card uk-card-default uk-card-body">
      <h3 class="uk-card-title uk-margin-remove-bottom">Arief</h3>
      <ul class="uk-margin-remove" style="margin-top: 10px !important">
        <li>
          <router-link
            to="/profile/transaction"
            :class="`${$route.name == 'Transaction' || $route.name == 'Transaction Detail' ? 'active-menu' : ''}`"
            >History Transaction <span class="uk-badge badge-transaction" style="float: right;" v-if="GET_NOTIF_ORDER > 0">{{ GET_NOTIF_ORDER }}</span></router-link
          >
        </li>
        <li>
          <router-link
            to="/profile"
            :class="`${$route.name == 'My Profile' ? 'active-menu' : ''}`"
            >My Profile</router-link
          >
        </li>
        <li class="logout-navigation">
          <a href="javascript:void(0)" @click="logout()">Logout</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  mounted() {
    // console.log(this.$route.name)
  },
  methods: {
    ...mapMutations("auth", ["SET_USER"]),
    ...mapMutations("cart", ["REMOVE_ALL_CART"]),
    logout() {
      window.location.href = '/';
      this.SET_USER(null);
      this.REMOVE_ALL_CART();
    },
  },
  computed: {
    ...mapGetters(['GET_NOTIF_ORDER'])
  }
};
</script>

<style lang="less" scoped>
@import "../custom/custom.less";

@media screen and (max-width: 959px) {
  .navigation-profile {
    font-size: 0.9714632665452337vw !important;

    .badge-transaction {
      min-width: 12px;
      height: 12px;
      font-size: 0.9714632665452337vw;
    }
  }
}

.navigation-profile {
  font-size: 14px;
  .uk-card-body {
    padding: 20px !important;
  }
  .logout-navigation {
    color: @danger-color;
    a:hover {
      text-decoration: none;
      background: @danger-color;
      color: white;
    }
  }
  ul {
    list-style: none;
    padding: 0;

    li {
      margin-bottom: 5px;
      a {
        color: @primary-color;
        display: block;
        padding: 5px 10px;
        border-radius: 5px;

        &:hover {
          text-decoration: none;
          background: @primary-color;
          color: white;
        }
      }
      .badge-transaction {
        color: white;
        background: @danger-color;
      }
      .active-menu {
        background: @primary-color;
        color: white;
      }
    }
  }
}
</style>